import { onMount, type Component } from "solid-js";
import { useNavigate } from "@solidjs/router";
import { signOut } from "../lib/auth";

const SignOut: Component = () => {
  const navigate = useNavigate();
  onMount(() => {
    signOut();
    navigate("/", { replace: true });
  });
  return null;
};

export default SignOut;
